"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MeasurementsModel {
    constructor(cache) {
        this.getMeasurements = async (customerId) => {
            return (await this.cache
                .getArray(this.getKey(customerId))
                .asPromise());
        };
        this.setMeasurements = async (customerId, measurements) => {
            return this.cache
                .setArray(this.getKey(customerId), measurements)
                .asPromise();
        };
        this.getKey = (customerId) => `${MeasurementsModel.MEASUREMENTS_DB}.${customerId}`;
        this.cache = cache;
    }
}
MeasurementsModel.MEASUREMENTS_DB = "Mock.Database.MEASUREMENTS_DB";
exports.default = MeasurementsModel;
//# sourceMappingURL=MeasurementsModel.js.map